import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../../store/auth.store";
import { authApi } from "../../api/auth.api";

interface TopBarProps {
  onMenuToggle: () => void;
}

export function TopBar({ onMenuToggle }: TopBarProps) {
  const { user, refreshToken, impersonator, clear, stopImpersonating } = useAuthStore();
  const navigate = useNavigate();
  const qc = useQueryClient();

  async function handleLogout() {
    if (impersonator) {
      stopImpersonating();
      qc.clear();
      return;
    }
    if (refreshToken) {
      try {
        await authApi.logout(refreshToken);
      } catch {
        // ignore network errors during logout
      }
    }
    clear();
    navigate("/login");
  }

  return (
    <div className="topbar">
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button className="menu-btn" onClick={onMenuToggle} aria-label="Open menu">☰</button>
        <div className="muted">
          {user?.displayName ?? user?.email}
          {user?.isPanelAdmin && (
            <span className="badge success" style={{ marginLeft: 8 }}>admin</span>
          )}
        </div>
      </div>
      <button onClick={handleLogout}>Sign out</button>
    </div>
  );
}
